<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Lista de Serviços</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel (filtros da lista)"
          icon="assets/exportar-excel.svg"
          (click)="exportarOrdemServico()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getServicos()">
            <div class="table-filters">
              <app-input
                label="Gate Entrada"
                placeholder="Digite"
                name="FK_GATE_ENTR"
                formControlName="FK_GATE_ENTR"
                width="100%"></app-input>
              <app-input
                label="Motorista"
                placeholder="Digite"
                name="NM_MTRT"
                formControlName="NM_MTRT"
                width="100%"></app-input>
              <app-input
                label="Placa do Cavalo"
                placeholder="Digite"
                name="TX_PLCA_CAVA"
                formControlName="TX_PLCA_CAVA"
                mask="AAA-0A00"
                width="100%"></app-input>
              <app-input
                type="datetime-local"
                label="Data do Início"
                placeholder="Digite aqui"
                name="DT_SRVC_ENTR_INIC"
                formControlName="DT_SRVC_ENTR_INIC"
                width="100%"></app-input>
              <app-input
                label="Data Fim"
                type="datetime-local"
                width="100%"
                class="pesquisa"
                name="DT_SRVC_ENTR_FIM"
                formControlName="DT_SRVC_ENTR_FIM"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Cód. Serviço"
        placeholder="Digite"
        name="FK_SRVC"
        formControlName="FK_SRVC"
        width="100%"></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite"
        name="FK_EPSA"
        formControlName="FK_EPSA"
        width="100%"></app-input>
      <app-input
        label="Placa do Cavalo"
        placeholder="Digite"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        mask="AAA-0A00"
        width="100%"></app-input>
      <app-input
        type="datetime-local"
        label="Data do Início"
        placeholder="Digite aqui"
        name="DT_SRVC_ENTR_INIC"
        formControlName="DT_SRVC_ENTR_INIC"
        width="100%"></app-input>
      <app-input
        label="Data Fim"
        type="datetime-local"
        width="100%"
        class="pesquisa"
        name="DT_SRVC_ENTR_FIM"
        formControlName="DT_SRVC_ENTR_FIM"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
